<section class="content-header">

   <div class="container-fluid">
     <div class="row mb-2">
       <div class="col-sm-6">
         <h1 class="m-0 text-dark">View Document</h1>
       </div>
 
     </div>
     <!-- /.row -->
   </div>
   <!-- /.container-fluid -->
 </section>
 <section class="content">
   <!-- Default box -->
   <div class="container-fluid">
 
     <div class="card">
 
       <div class="card-body">
 
        <br />
      <div class="box-header with-border">
       <p style="float:right"><input type="button" class="btn btn-link" (click)="back()" class="btn btn-link" value="Go Back"></p>
      
   </div>
   <br />
   <!-- <div *ngIf="type=='img'">
         <table class="table table-striped table-hover table-bordered">
           <thead class="thead">
             <tr>
               <td style="font-weight:bold">Sr No.</td>
               <td style="font-weight:bold">File Name</td>
             </tr>
           </thead>
 
           <tbody>
             <tr *ngFor="let image of images | paginate : {itemsPerPage: 10, currentPage : p}; let i=index">
               <td><a href="{{image.filepath}}" style="text-decoration: none;" target="_blank" >{{ itemsPerPage * (p - 1) + i + 1 }}</a></td>
              
               </tr>
           </tbody>
         </table>
         <pagination-controls (pageChange)="p = $event" class="float-right"></pagination-controls>
       </div> -->
       <div *ngIf="categ=='training'">Training Title: {{title}}</div>
       <div *ngIf="categ=='awp'">Program Title: {{title}}</div>
       <div>
         <table class="table table-striped table-hover table-bordered">
           <thead class="thead">
             <tr>
               <td style="font-weight:bold">Sr. No.</td>
               <td style="font-weight:bold">File Name</td>
               <!-- <td style="font-weight:bold">View</td> -->
             </tr>
           </thead>
 
           <tbody>
             <tr *ngFor="let doc of docs | paginate : {itemsPerPage: 10, currentPage : p}; let i=index">
               <td>{{ itemsPerPage * (p - 1) + i + 1 }}</td>
               <td> <a href='{{doc.filepath}}' style="text-decoration: none;" target="_blank" >{{doc.filename}}</a></td>
               <!-- <td>
                  <div class="icon">
                     
                        <a href='{{doc.filepath}}' style="text-decoration: none;" target="_blank" >
                          View
                         </a>
                     </div>
               </td>    -->
             </tr>
           </tbody>
         </table>
         <!-- <pagination-controls (pageChange)="p = $event" class="float-right"></pagination-controls> -->
       </div>
       </div>
     </div>
   </div>
 </section>
 <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
   <p style="color: white">Please Wait. </p>
 </ngx-spinner>
 